import {
  LOADING_WORKTYPE,
  LOADING_WORKTYPE_SUCCESS,
  LOAD_WORKTYPE,
  WORKTYPE_SAVE_NOT,
  WORKTYPE_SAVE_SUCCESS,
} from "../types/worktype.types";

export type WorktypeType = {
  id: string;
  work_type: string;
};

export type WorktypeStateType = {
  loading: boolean;
  worktypes: WorktypeType[];
  totalPage: number;
  save: boolean;
  currentPage: number;
  itemsOnPage:number;
  totalRows:number

};

const initialState: WorktypeStateType = {
  loading: true,
  worktypes: [],
  totalPage: 0,
  save: false,
  currentPage: 1,
  itemsOnPage:10,
  totalRows:0,
};

export default function worktypeReducer(state = initialState, action:any) {
  switch (action.type) {
    case LOAD_WORKTYPE:
      return { ...state, worktypes: action.payload.results,totalRows:action.payload.count,currentPage:action.payload.current };
    case LOADING_WORKTYPE:
      return { ...state, loading: true };
    case LOADING_WORKTYPE_SUCCESS:
      return { ...state, loading: false };
    case WORKTYPE_SAVE_NOT:
      return { ...state, save: false };
    case WORKTYPE_SAVE_SUCCESS:
      return { ...state, save: true };
    default:
      return state;
  }
}
